import { css } from 'styled-components';
import { getColorByName } from '~/helpers/getColors';
import { mq } from '~/styles/grid';

const CopytextBasics = css`
  font-family: ${(props) => props.theme.font.regular};
  b,
  strong {
    font-family: ${(props) => props.theme.font.bold};
    font-weight: 700;
  }
`;

export const CopyBigSkin = css`
  ${CopytextBasics};
  font-size: ${(props) => props.theme.copytext.copyBig.fontSize};
  line-height: ${(props) => props.theme.copytext.copyBig.lineHeight};
  color: ${(props) =>
    getColorByName(props.theme, props.theme.copytext.copyBig.textColor)};

  @media (${mq.smDown}) {
    font-size: ${(props) => props.theme.copytext.copyBig.fontSizeXs};
    line-height: ${(props) => props.theme.copytext.copyBig.lineHeightXs};
  }

  ul li {
    &:before {
      top: calc(${(props) => props.theme.copytext.copyBig.fontSize} - 3px);
      @media (${mq.smDown}) {
        top: calc(${(props) => props.theme.copytext.copyBig.fontSizeXs} - 5px);
      }
    }
  }
`;

export const CopyStandardSkin = css`
  ${CopytextBasics};
  font-size: ${(props) => props.theme.copytext.copyStandard.fontSize};
  line-height: ${(props) => props.theme.copytext.copyStandard.lineHeight};
  color: ${(props) =>
    getColorByName(props.theme, props.theme.copytext.copyStandard.textColor)};

  @media (${mq.smDown}) {
    font-size: ${(props) => props.theme.copytext.copyStandard.fontSizeXs};
    line-height: ${(props) => props.theme.copytext.copyStandard.lineHeightXs};
  }

  ul li {
    &:before {
      top: calc(${(props) => props.theme.copytext.copyStandard.fontSize} - 3px);
      @media (${mq.smDown}) {
        top: calc(
          ${(props) => props.theme.copytext.copyStandard.fontSizeXs} - 5px
        );
      }
    }
  }
`;

export const CopyFineprintSkin = css`
  ${CopytextBasics};
  font-size: ${(props) => props.theme.copytext.copyFineprint.fontSize};
  line-height: ${(props) => props.theme.copytext.copyFineprint.lineHeight};
  color: ${(props) =>
    getColorByName(props.theme, props.theme.copytext.copyFineprint.textColor)};

  @media (${mq.smDown}) {
    font-size: ${(props) => props.theme.copytext.copyFineprint.fontSizeXs};
    line-height: ${(props) => props.theme.copytext.copyFineprint.lineHeightXs};
  }

  ul li {
    &:before {
      top: calc(
        ${(props) => props.theme.copytext.copyFineprint.fontSize} - 3px
      );
      @media (${mq.smDown}) {
        top: calc(
          ${(props) => props.theme.copytext.copyFineprint.fontSizeXs} - 5px
        );
      }
    }
  }
`;
